var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBlob5(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 500 500",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "100%",
    id: "blobSvg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient",
    x1: "0%",
    y1: "0%",
    x2: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "rgb(255, 95, 109)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "rgb(255, 195, 113)"
    }
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "blob",
    d: "M474.5,288Q484,326,455.5,352.5Q427,379,401.5,401Q376,423,351,453.5Q326,484,288,480.5Q250,477,213,476.5Q176,476,142,460.5Q108,445,83.5,417Q59,389,45,355Q31,321,16,285.5Q1,250,13,213.5Q25,177,43.5,145.5Q62,114,97,101Q132,88,157.5,66Q183,44,216.5,26Q250,8,283,27.5Q316,47,352,53.5Q388,60,413,86.5Q438,113,462,143Q486,173,475.5,211.5Q465,250,474.5,288Z",
    fill: "none",
    strokeWidth: "7px",
    stroke: "url(#gradient)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlob5);
export default __webpack_public_path__ + "static/media/blob5.29ef0369d35f5a84dae88e4cd56bdaad.svg";
export { ForwardRef as ReactComponent };